import React from 'react';
import { Box, Typography, Button, makeStyles } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    borderRadius: 10,
    backgroundColor: '#fffbfb',
    border: '1px solid #fde8e8',
    boxShadow: '0 1px 4px rgba(239,68,68,0.08)',
    width: '100%',
    boxSizing: 'border-box',
  },
  iconWrap: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    backgroundColor: '#fee2e2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginTop: 2,
  },
  icon: {
    color: '#ef4444',
    fontSize: 18,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontSize: '0.9rem',
    fontWeight: 600,
    color: '#374151',
    lineHeight: 1.4,
    marginBottom: 2,
  },
  description: {
    fontSize: '0.8rem',
    color: '#6b7280',
    lineHeight: 1.5,
  },
  retry: {
    marginTop: theme.spacing(1),
    fontSize: '0.75rem',
    color: '#6b7280',
    textTransform: 'none',
    padding: '3px 10px',
    minWidth: 0,
    border: '1px solid #e5e7eb',
    borderRadius: 6,
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#f9fafb',
      borderColor: '#d1d5db',
    },
  },
}));

interface InlineErrorProps {
  title: string;
  description?: string;
  onRetry?: () => void;
}

export const InlineError = ({ title, description, onRetry }: InlineErrorProps) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box className={classes.iconWrap}>
        <ErrorOutlineIcon className={classes.icon} />
      </Box>
      <Box className={classes.content}>
        <Typography className={classes.title}>{title}</Typography>
        {description && (
          <Typography className={classes.description}>{description}</Typography>
        )}
        {onRetry && (
          <Button
            className={classes.retry}
            startIcon={<RefreshIcon style={{ fontSize: 13 }} />}
            onClick={onRetry}
          >
            Try again
          </Button>
        )}
      </Box>
    </Box>
  );
};
